'use client';

import { ChakraProvider as ChakraUIProvider } from '@chakra-ui/react';
import { ReactNode } from 'react';
import theme from './theme';

interface ChakraProviderProps {
  children: ReactNode;
}

/**
 * Wrapper component for Chakra UI Provider with custom theme
 * @param props - The component props
 * @param props.children - React children to be wrapped
 * @returns JSX.Element
 */
export default function ChakraProvider({ children }: ChakraProviderProps) {
  return <ChakraUIProvider theme={theme}>{children}</ChakraUIProvider>;
}
